module.exports = __webpack_public_path__ + "static/img/bg-empty-pattern.fa8b06b1.png";